import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	forYouLabel: {
		id: 'navigation.global-side-navigation.for-you.label',
		description:
			'Label on For You button in the side navigation. Typically takes users to an app-specific page showing user content',
		defaultMessage: 'For you',
	},
});
